
export default {
  fields:  [
    {
      "type": "text",
      "labelCode": "institutes.name",
      "name": "institute.name",
      "validations": {
        "required": {
          "messageCode": "institutes.name_is_mandatory"
        }
      }
    }
  ]
}
